/* ══════════════════════════════════════════
   Kreide-Filter — die SVG-Filter des Doodle-Looks
   ──────────────────────────────────────────
   Werte wörtlich aus vendor/dpsg/js/doodles.js. Dort legt eine IIFE die
   Filter beim Laden ins DOM; die Datei kann das Dashboard nicht direkt
   nutzen, weil ihr übriger Teil auf Website-Selektoren zeigt (.hero-door,
   .news-card …). Deshalb nur diese Definitionen, einmal gerendert.

   Ändert sich der Look auf der Website, kommen die Werte von dort —
   nicht hier nachjustieren.

   #chalkf       fein-körnig — Rahmen, Buttons, Karten, Felder
   #chalkf-ic    Icons (mittlere Verzerrung)
   #chalkf-text  sehr sanft — nur Wortmarken
   #chalkf-lily  große Flächen (niedrige Frequenz, großer Scale)
   ══════════════════════════════════════════ */

export function ChalkFilters() {
  return (
    <svg
      aria-hidden="true"
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
    >
      <defs>
        <filter id="chalkf" x="-20%" y="-20%" width="140%" height="140%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.42"
            numOctaves="2"
            seed="7"
            result="n"
          />
          <feDisplacementMap
            in="SourceGraphic"
            in2="n"
            scale="2.2"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
        <filter id="chalkf-ic" x="-35%" y="-35%" width="170%" height="170%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.22"
            numOctaves="2"
            seed="4"
            result="n"
          />
          <feDisplacementMap
            in="SourceGraphic"
            in2="n"
            scale="1.8"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
        <filter id="chalkf-text" x="-6%" y="-8%" width="112%" height="116%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.02"
            numOctaves="1"
            seed="3"
            result="n"
          />
          <feDisplacementMap
            in="SourceGraphic"
            in2="n"
            scale="1.7"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
        <filter id="chalkf-lily" x="-30%" y="-30%" width="160%" height="160%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.045"
            numOctaves="2"
            seed="5"
            result="n"
          />
          <feDisplacementMap
            in="SourceGraphic"
            in2="n"
            scale="12"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
  );
}
